<template>
  <j-modal :title="title"
    :width="width"
    :visible="visible"
    destroyOnClose
    :confirmLoading="confirmLoading"
    @cancel="handleCancel"
    :footer="null">
    <a-spin :spinning="confirmLoading">
      <a-form :form="form">
        <a-row :gutter="24">
          <a-col :md="24"
            :sm="24">
            <a-form-item label="来源名称"
              :labelCol="labelCol"
              :wrapperCol="wrapperCol">
              <a-input placeholder="来源名称"
                v-decorator="['sourceName', validatorRules.sourceName]" />
            </a-form-item>
          </a-col>
          <a-col :md="24"
            :sm="24">
            <a-form-item label="签名"
              :labelCol="labelCol"
              :wrapperCol="wrapperCol">
              <m-ore-select url="/base/busCommonMessageSignatures/listAll"
                @callBack="callBack"
                :asterisk="false"
                showItem
                :params="{}"
                parameter="projectName"
                placeholder="签名"
                v-decorator="['signatures', validatorRules.signatures]">
              </m-ore-select>
            </a-form-item>
          </a-col>
          <a-col :md="24"
            :sm="24">
            <a-form-item label="备注"
              :labelCol="labelCol"
              :wrapperCol="wrapperCol">
              <a-textarea placeholder="备注"
                v-decorator="['memo', validatorRules.memo]"
                :rows="4" />
              </m-ore-select>
            </a-form-item>
          </a-col>
        </a-row>
        <div class="btn-box">
          <div class="btn">
            <a-button type="primary"
              @click="handleOk"
              size="large"
              block>
              确认
            </a-button>
          </div>
          <div class="btn">
            <a-button block
              size="large"
              @click="handleReset">
              取消
            </a-button>
          </div>
        </div>
      </a-form>
    </a-spin>
  </j-modal>
</template>

<script>
import { httpAction, getAction } from '@/api/manage'
import pick from 'lodash.pick'
import { validateDuplicateValue } from '@/utils/util'
import merge from 'webpack-merge'
import HOneSelecTag from './HOneSelecTag.vue'
import MOreSelect from './NAmeMOreSelect.vue'
export default {
  name: 'DeliveryFinishModal',
  props: {},
  components: {
    MOreSelect,
    HOneSelecTag
  },
  data() {
    return {
      form: this.$form.createForm(this),
      title: '操作',
      width: 800,
      visible: false,
      model: {},
      labelColl: {
        xs: { span: 24 },
        sm: { span: 6 },
        md: { span: 4 }
      },
      wrapperColl: {
        xs: { span: 24 },
        sm: { span: 18 },
        md: { span: 20 }
      },
      labelCol: {
        xs: { span: 24 },
        sm: { span: 14 },
        md: { span: 8 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 10 },
        md: { span: 16 }
      },
      confirmLoading: false,
      backForm: {},
      url: {
        busCommonMessageAccountNewAdd: '/base/busCommonMessageSourceNew/add',
        busCommonMessageAccountNewEdit: '/base/busCommonMessageSourceNew/edit'
      },
      validatorRules: {
        sourceName: {
          rules: [{ required: true, message: '请输入来源名称!' }]
        },
        signatures: {
          rules: [{ required: true, message: '请选择签名!' }]
        },
        memo: {
          rules: []
        },
      },
    }
  },
  watch: {
    mainId: {
      immediate: true,
      handler(val) { }
    }
  },
  created() { },
  methods: {
    edit(record, id) {
      this.form.resetFields()
      const that = this
      this.model = Object.assign({}, record)
      this.visible = true
      setTimeout(() => {
        this.$nextTick(() => {
          this.form.setFieldsValue(pick(this.model, 'sourceName', 'signatures', 'memo'))
        })
      }, 300)
    },
    close() {
      this.$emit('close')
      this.visible = false
    },
    handleOk() {
      const that = this
      // 触发表单验证
      this.form.validateFields((err, values) => {
        if (!err) {
          that.confirmLoading = true
          let url = that.url.busCommonMessageAccountNewAdd
          if (that.model.id) {
            values = Object.assign({}, that.model, values);
            url = that.url.busCommonMessageAccountNewEdit
          }
          httpAction(url, values, 'post')
            .then(res => {
              if (res.success) {
                that.$emit('ok', '短信来源创建成功', '短信来源创建成功')
              } else {
                that.$message.warning(res.message)
              }
            })
            .finally(() => {
              that.confirmLoading = false
              that.handleCancel()
            })
        }
      })
    },
    handleCancel() {
      this.close()
    },
    callBack(item) {
      console.log(item)
    },
    handleReset() {
      this.form.resetFields()
      this.visible = false
    }
  }
}
</script>
<style lang="less" scoped>
.btn-box {
  display: flex;
  justify-content: space-around;
  align-items: center;
  width: 60%;
  margin: 0 auto;
  .btn {
    width: 40%;
  }
}
</style>
